export default __webpack_public_path__ + "static/media/330_store01-it-web.8e6a3242.png";